/**
 * THE WAYS TO PAY, FOLDED AWAY after a lesser face (the seam, l.726-730 at b727ec1): drawn as they
 * are, or, while a lesser face counts, behind "Ways to pay this invoice", a button that opens them
 * and says whether they are open. An invoice's page folds its ways to pay with it, and so does an
 * invoice its saved method pays, which folds away its Zelle.
 */
import { useId, type ReactNode } from 'react';
import { INVOICE_FEEDBACK } from '../words.ts';
import { GHOST_BUTTON } from './buttons.ts';
import { Chevron } from './Chevron.tsx';

interface FoldingProps {
  /** A lesser face counts, so what is given folds away. */
  readonly folding: boolean;
  /** She has opened it again. */
  readonly open: boolean;
  readonly onToggle: () => void;
  readonly children: ReactNode;
}

export function Folding({ folding, open, onToggle, children }: FoldingProps) {
  const regionId = useId();
  if (!folding) return <>{children}</>;
  return (
    <div>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={regionId}
        onClick={onToggle}
        className={`gap-2 ${GHOST_BUTTON}`}
      >
        {INVOICE_FEEDBACK.waysToPay}
        <Chevron open={open} />
      </button>
      {open ? (
        <div id={regionId} className="mt-4">
          {children}
        </div>
      ) : null}
    </div>
  );
}
